export const actionTypes = {
  SET_INSURANCE_INFO_IS_LOADING: 'MEMBERS/SET_INSURANCE_INFO_IS_LOADING',
  FETCH_INSURANCE_INFO: 'MEMBERS/FETCH_INSURANCE_INFO',
  UPDATE_INSURANCE_INFO: 'MEMBERS/UPDATE_INSURANCE_INFO',
  RESET_INSURANCE_INFO: 'MEMBERS/RESET_INSURANCE_INFO',
};
